import './App.css';
import { useState, useEffect } from 'react';
import { Auth, Hub } from 'aws-amplify';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import awsconfig from './aws-exports';
import '@aws-amplify/ui-react/styles.css';
import InactivityLogout from './components/InactivityLogout';
import Home from './pages/Home';
// import Selector from 'pages/Selector';
import About from './pages/About';
import Navbar from './components/Navbar';
import HowTo from './pages/HowTo';
import LeadsheetUploadForm from './pages/LeadsheetUpload/LeadsheetUploadForm'
import JobsDashboard from './pages/JobsDashboard/JobsDashboard'
import Networks from './pages/Networks/Networks'
import Stats from './pages/Stats/Stats';
import UnderConstructionPage from './pages/UnderConstructionPage';
import Selector from 'pages/Selector';
import Status from './pages/Status';
import Footer from './components/Footer'
import WebScraping from './pages/WebScraping';
import { AuthComponents, formFields } from './components/AuthComponents';

Auth.configure(awsconfig);

function App() {

  const { user, authStatus } = useAuthenticator((context) => [context.user, context.authStatus]);
  const navigate = useNavigate();
  const [group, setGroup] = useState(null);

  useEffect(() => {
    if (user) {
      setGroup(user.signInUserSession.idToken.payload['cognito:groups']?.[0]);
    }
  }, [user]);

  const handleGroupChange = (newGroup) => {
    setGroup(newGroup);
  };

  useEffect(() => {
    Hub.listen("auth", (data) => {
      if (data?.payload?.event === "signIn") {
        navigate("/");
      }
    });
  }, []);

  return (
    <div>
      {authStatus === 'authenticated' && <InactivityLogout />}
      <Routes>
        <Route path="/" element={<Navbar group={group} />}>
          <Route index element={<Home />} />
          <Route path="About" element={<About />} />
          {/* There is probably a better way to do this, amplify's withAuthenticator HOC has similar functionallity but makes it much harder to customize UX -AC */}
          <Route path="Login" element={authStatus !== 'authenticated' ? <Authenticator hideSignUp={true} formFields={formFields} components={AuthComponents} /> : <Navigate to="/" />} />
          <Route path="Selector" element={authStatus !== 'authenticated' ? <Authenticator hideSignUp={true} formFields={formFields} components={AuthComponents} /> : <Selector group={group} handleGroupChange={handleGroupChange} />} />
          <Route path="HowTo" element={authStatus !== 'authenticated' ? <Authenticator hideSignUp={true} formFields={formFields} components={AuthComponents} /> : <HowTo />} />
          <Route path="LeadsheetUpload" element={authStatus !== 'authenticated' ? <Authenticator hideSignUp={true} formFields={formFields} components={AuthComponents} /> : <LeadsheetUploadForm />} />
          <Route path="JobsDashboard" element={authStatus !== 'authenticated' ? <Authenticator hideSignUp={true} formFields={formFields} components={AuthComponents} /> : <JobsDashboard />} />
          <Route path="WebScraping" element={authStatus !== 'authenticated' ? <Authenticator hideSignUp={true} formFields={formFields} components={AuthComponents} /> : <WebScraping />} />
          <Route path="NetworkGeneration" element={authStatus !== 'authenticated' ? <Authenticator hideSignUp={true} formFields={formFields} components={AuthComponents} /> : <UnderConstructionPage />} />
          <Route path="Networks" element={authStatus !== 'authenticated' ? <Authenticator hideSignUp={true} formFields={formFields} components={AuthComponents} /> : <Networks />} />
          <Route path="Stats" element={authStatus !== 'authenticated' ? <Authenticator hideSignUp={true} formFields={formFields} components={AuthComponents} /> : <Stats />} />

          <Route path="Status" element={authStatus !== 'authenticated' ? <Authenticator hideSignUp={true} formFields={formFields} components={AuthComponents} /> : <Status />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
